import forms from "@/data/forms.json"

export default {
  fields: forms.fields,
}
